module.exports = __webpack_public_path__ + "media/images/webinar-4-ea7192187224779b79d5319a453c3760.png";